var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fel-item",class:{ active: _vm.collection.active },on:{"click":_vm.click}},[_c('div',{staticClass:"fel-image"},[_c('img',{attrs:{"src":_vm.collectionImageUrl,"alt":_vm.collectionTitle}})]),_c('div',{staticClass:"fel-overlay"},[_c('div',{staticClass:"fel-title"},[_vm._v(_vm._s(_vm.truncate(_vm.collectionTitle, 25)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }